import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'typeof' })
export class TypeofPipe implements PipeTransform {

  transform(input: string, type: string, operator: string = null): boolean {
    return operator === 'not' ? typeof input !== type : typeof input === type;
  }
}
